export const EVENT_NAME = {
  ATTEMPT: "Attempt",
  SUCCESS: "Success",
  ERROR: "Error",
  SAW: "Saw",
  CLICKED: "Clicked",
  SKIP: "Skip"
};
